/* globals _cookieDomain_, _sentryJsDsn_, _googleApiKey_, _segmentKey_, _googleReCaptchaKey_, _application_env_ */

function DynamicUrl(url, defaultParams){
    defaultParams = defaultParams || {};

    function render(params){
        params = params || {};

        return url.replace(/\{([^{}]*)\}/g, function (match, property) {
            return params[property] || defaultParams[property] || '';
        });
    }

    this.render = render;
}

function configSetup(configParams, environment, apiUri) {
    configParams = configParams || {};

    var params = ObjectAssign.assign({}, configParams, {
        appUri: apiUri.render() + 'app/',
        apiV2Uri: apiUri.render() + 'api/v2/',
        appV1Uri: apiUri.render() + 'app/',
        baseUrl: apiUri.render(),
        environment: environment,
        environmentDomain: getEnvDomain(environment)
    });

    return params;
}

function getCsrfTokenName(){
    return _csrfToken_;
}

function getEnvDomain(environment){
    var envDomain = '',
        dynamicUrl = '';

    switch (environment) {
    case 'development':
        dynamicUrl = new DynamicUrl('{branch}-s'+_cookieDomain_, {
            branch: window.location.host.match(/^(\S+)-\S+$/)[1]
        });
        envDomain = dynamicUrl.render().replace('www', '');
        break;
    default:
        envDomain = _cookieDomain_;
        break;
    }

    return envDomain;
}

var Config = (function (configSetup) {
    'use strict';

    return configSetup(
        {
            sentryUrl: _sentryJsDsn_,
            googleMapsKey: _googleApiKey_,
            segmentKey: _segmentKey_,
            reCaptchaKey: _googleReCaptchaKey_
        },
        _application_env_,
        new DynamicUrl('https://www' + _cookieDomain_ + '/')
    );

})(configSetup);

Config.getReleaseVersion = function () {
    var deferred = $.Deferred();

    if (Config.releaseVersion) {
        return deferred.promise().resolve(Config.releaseVersion);
    }

    $.ajax({
        url: '/api/v2/about/release',
        type: 'GET',
        success: function (response) {
            Config.releaseVersion = response.version;
            deferred.resolve(response.version);
        },
        error: function (response) {
            deferred.reject(response && response.error ? response.error : response);
        }
    });

    return deferred.promise();
};
